export default __webpack_public_path__ + "static/media/Kel'Avashk Cap.36074372.jpg";